export default __webpack_public_path__ + "static/Automated-Insights-Newsletter-9c44036b440e2ce4c31fd48454e9181e.jpg";